import { Box, Text } from "@chakra-ui/react";
import React from "react";

export type BadgePillStatus = "success" | "warning" | "secondary" | "danger";

interface BadgePillProps {
  label: string;
  status: BadgePillStatus;
}

const resolveBg = (status: BadgePillStatus) => {
  const map: Record<BadgePillStatus, string> = {
    success: "green.500",
    warning: "yellow.500",
    secondary: "gray.500",
    danger: "red.500",
  };

  return map[status];
};

const resolveTextColor = (status: BadgePillStatus) => {
  if (status === "warning") {
    return "black";
  }

  return "white";
};

export const BadgePill = ({ label, status }: BadgePillProps) => (
  <Box py={1} px={2} borderRadius="2xl" bg={resolveBg(status)}>
    <Text color={resolveTextColor(status)}>{label}</Text>
  </Box>
);
